import React from 'react';
import { Collapse, Checkbox, Divider } from 'antd';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { format, parseISO } from 'date-fns';

const { Panel } = Collapse;

const DespatchBoxBoxList = (props) => {

    const build_check_process = (order) => (
        <Checkbox
            style={{ marginRight: '15px' }}
            checked={order ? order.checked === 1 ? true : false : false}
            onClick={event => {
                event.stopPropagation();
            }}
            onChange={() => {
                props.updateDataOrdersChecked(order);
            }}>
        </Checkbox>
    )

    const buildDeleteBtn = (order) => (
        <BasicPopconfirm
            label='Eliminar orden'
            title='¿Seguro/a que deseas eliminar orden?'
            onConfirm={() => { props.deleteOrder(order) }}
            button={
                <IconButton color="error" aria-label="delete" onClick={(e) => e.stopPropagation()}>
                    <DeleteIcon />
                </IconButton>
            }
        />
    )

    const genExtra = (order) => (
        <div>

            <IconButton style={{ marginRight: '10px' }} color="primary" aria-label="pdf"
                onClick={(e) => { e.stopPropagation(); props.displayPDF(order); }}>
                <PictureAsPdfIcon />
            </IconButton>
            {
                build_check_process(order)
            }
        </div>
    );

    const buildTotalValue = (data) => {
        let total = 0;
        data.forEach(element => {
            total += (element.price * element.quantity);
        });
        return total;
    }

    return (
        <Collapse
            defaultActiveKey={[]}
            expandIconPosition={'right'}
        >
            {
                props.data.map((d, key) => {
                    return (
                        <Panel
                            style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
                            key={key + 1}
                            extra={genExtra(d)}
                            header={
                                <>
                                    <strong style={{ marginRight: '20px' }}>{`Orden: ${d.id}`}</strong>
                                    <strong>{`Cliente: ${d.ordersDetail.length > 0 ? d.ordersDetail[0].productPrice ? d.ordersDetail[0].productPrice.client ? d.ordersDetail[0].productPrice.client.name : '' : '' : ''}`}</strong>
                                    <Chip style={{ marginLeft: '20px' }} label={`Pedido: ${d.date_created ? format(parseISO(d.date_created), 'dd-MM-yyyy HH:mm:ss') : 'Sin Fecha'}`} size='small' color="primary" variant="outlined" />
                                    <Chip style={{ marginLeft: '20px' }} label={`Entrega: ${d.date_delivery ? format(parseISO(d.date_delivery), 'dd-MM-yyyy HH:mm:ss') : 'INMEDIATA'}`} size='small' color="warning" variant="outlined" />
                                </>
                            }
                        >
                            {
                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td colSpan={6} style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                Dirección de envío: {d.address_delivery}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={6}>
                                                <Divider style={{ marginTop: '-1px', marginBottom: '-10px' }} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Producto
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Color
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Cantidad
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Porceso
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Fecha Crudo
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Fecha Tintoreria
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Fecha Enrollado
                                            </td>
                                            <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                                                Fecha Despachos
                                            </td>
                                        </tr>
                                        {d.ordersDetail.map((od, key) => {
                                            return (
                                                <tr key={key + 'itemOd'}>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.productPrice ? od.productPrice.product ? od.productPrice.product.ref : '' : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.color.cod ? od.color.cod : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.quantity ? od.quantity + ' ' + od.type_quantity : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.cod_process ? od.cod_process : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.fecha_crudo ? format(parseISO(od.fecha_crudo), 'dd-MM-yyyy HH:mm:ss') : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.fecha_tintoreria ? format(parseISO(od.fecha_tintoreria), 'dd-MM-yyyy HH:mm:ss') : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.fecha_enrollado ? format(parseISO(od.fecha_enrollado), 'dd-MM-yyyy HH:mm:ss') : ''}
                                                    </td>
                                                    <td style={{ border: '1px solid #c9c9c9', textAlign: 'center', fontSize: '10px', fontFamily: 'monospace' }}>
                                                        {od.fecha_despachos ? format(parseISO(od.fecha_despachos), 'dd-MM-yyyy HH:mm:ss') : ''}
                                                    </td>

                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            }

                        </Panel>
                    );
                })
            }
        </Collapse>
    );

}
export default DespatchBoxBoxList;